module.exports = __webpack_public_path__ + "static/media/ic-arrow-4.030fea88.svg";